// extracted by mini-css-extract-plugin
export default {"button":"yRtBDPULx788KGofSHeT","disabled":"JLvBixWxLf_v8zD3W7fi"};